import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { apiClient } from "src/utils/Api/apiClient";

interface forgotPasswordState {
	response: string | null;
	forgotPasswordLoading: boolean;
	forgotPasswordError: string | null;
}

const initialState: forgotPasswordState = {
	response: null,
	forgotPasswordLoading: false,
	forgotPasswordError: null
}

export const forgotPassword = createAsyncThunk(
	'auth/forgotPassword',
	async (credentials: any, { rejectWithValue }) => {
		try {
			const response = await apiClient.post('auth/forgotPassword', credentials);
			return response.data;
		} catch (forgotPasswordError: any) {
			return rejectWithValue(forgotPasswordError.response.data || 'An error occured');
		}
	}
);

const forgotPasswordSlice = createSlice({
	name: 'forgotPassword',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		//user registration reducers
		builder.addCase(forgotPassword.pending, (state) => {
			state.forgotPasswordLoading = true;
			state.forgotPasswordError = null;
		});
		builder.addCase(forgotPassword.fulfilled, (state, action) => {
			state.response = action.payload;
			state.forgotPasswordError = null;
			state.forgotPasswordLoading = false;
		});
		builder.addCase(forgotPassword.rejected, (state, action) => {
			state.forgotPasswordLoading = false;
			state.forgotPasswordError = action.payload as string;
		});

	}
});

export const { reset } = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;
